import {SseNotification} from './sse-notification.model';

export class BookSseNotification extends SseNotification {

  public date: string;
  public startTime: string;
  public endTime: string;
  public vetcodeId: number;
  public whObjectId: number;

  constructor() {
    super();
  }

  getStartDateTime(): string {
    if (this.date && this.startTime) { return `${this.date} ${this.startTime}`; }
  }
}
